import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { hrAPI } from '@/lib/api';
import { toast } from 'sonner';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { CheckCircle } from 'lucide-react';
import { TestTaker } from './TestTaker';

export default function TakeTestPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState('');
  const [done, setDone] = useState(null);

  useEffect(() => {
    (async () => {
      try { setData((await hrAPI.takeTest(id)).data); }
      catch (e) { setErr(e.response?.data?.detail || 'Cannot open test'); }
    })();
  }, [id]);

  const submit = async (answers) => {
    try { const r = await hrAPI.submitTest2(id, { answers }); setDone(r.data); toast.success(`Submitted: ${r.data.score}/${r.data.total}`); }
    catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
  };

  if (done) return <div className="max-w-md mx-auto py-16 text-center" data-testid="test-done"><CheckCircle className="w-12 h-12 text-emerald-500 mx-auto mb-3" /><h1 className="text-xl font-bold">Test submitted</h1><p className="text-slate-600 mt-1">Your score: <b>{done.score}/{done.total}</b></p><Button className="mt-4" variant="outline" onClick={() => navigate('/hr/competency-tests')}>Back to Tests</Button></div>;
  if (err) return <Card className="max-w-md mx-auto mt-10 border-slate-200"><CardContent className="p-6 text-center"><p className="text-sm text-red-600">{err}</p><Button className="mt-3" variant="outline" onClick={() => navigate('/hr/competency-tests')}>Back</Button></CardContent></Card>;
  if (!data) return <p className="text-center text-slate-400 py-10 text-sm">Loading test...</p>;
  return <TestTaker title={data.name} questions={data.questions} timeLimitMin={data.time_limit_min} onSubmit={submit} />;
}
